import envVariables from '../consts/envVariables';

export const ALLOWED_ENVS_FOR_LOCALHOST = ['dev', 'dev1', 'dev3'];
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '::1'];

const getIsLocalhost = () => {
    if (typeof window === 'undefined') return false;

    const hostname = window?.location?.hostname;

    return LOCAL_HOSTNAMES.includes(hostname);
};

const getShouldSkipIapRequestsOnLocalhost = () => {
    if (!getIsLocalhost()) return false;

    const isAllowedEnv = ALLOWED_ENVS_FOR_LOCALHOST.includes(envVariables.ENV);

    return !isAllowedEnv;
};

export default {
    ALLOWED_ENVS_FOR_LOCALHOST,
    getIsLocalhost,
    getShouldSkipIapRequestsOnLocalhost,
};
